import type { Session } from '@/services/authApi';

export const SESSION_STORAGE_KEY = 'nemolaunchpad.session';
export const SESSION_CHANGE_EVENT = 'nemo:session';

export function readStoredSession(): Session | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Session) : null;
  } catch {
    return null;
  }
}

export function writeStoredSession(session: Session | null): void {
  try {
    if (session) {
      window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
    } else {
      window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
  } catch {
    // Private browsing / storage disabled: the session simply stays in memory.
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(SESSION_CHANGE_EVENT));
  }
}
